//Generated File 
export const DirectInNewPage = `DirectInNewPage`;
export const DirectInPopup = `DirectInPopup`;
export const ParamsInNewPage = `ParamsInNewPage`;
export const ParamsInPopup = `ParamsInPopup`;
export const Print = `Print`;
